import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldBan, Trash2, Plus } from "lucide-react";

export default function AdminSuppression() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ phone: "", email: "", reason: "" });

  const load = () => api.get("/admin/suppression").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.phone && !form.email) { toast.error("Enter a phone or email"); return; }
    try { await api.post("/admin/suppression", form); toast.success("Added to suppression list"); setForm({ phone: "", email: "", reason: "" }); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { await api.delete(`/admin/suppression/${id}`); load(); };

  return (
    <div>
      <PageHeader title="Suppression / Do Not Contact" subtitle="Centralized list. Suppressed contacts are blocked from outreach across all MLO accounts. National and state Do-Not-Call checks run automatically through RealValidation." />
      <Card className="mb-5 p-5">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
          <div><Label className="text-xs">Phone</Label><Input value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} data-testid="sup-phone" /></div>
          <div><Label className="text-xs">Email</Label><Input value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} data-testid="sup-email" /></div>
          <div><Label className="text-xs">Reason</Label><Input value={form.reason} onChange={(e) => setForm((f) => ({ ...f, reason: e.target.value }))} data-testid="sup-reason" /></div>
          <div className="flex items-end"><Button onClick={add} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="add-suppression-btn"><Plus className="mr-1 h-4 w-4" /> Add</Button></div>
        </div>
      </Card>
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-100 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Phone</th><th className="px-4 py-3">Email</th><th className="hidden px-4 py-3 md:table-cell">Reason</th><th className="hidden px-4 py-3 md:table-cell">Added</th><th className="px-4 py-3"></th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-slate-400"><ShieldBan className="mx-auto mb-2 h-8 w-8 text-slate-300" />No suppressed contacts.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`suppression-${r.id}`}>
                <td className="px-4 py-3 font-mono text-slate-700">{r.phone || "—"}</td>
                <td className="px-4 py-3 text-slate-700">{r.email || "—"}</td>
                <td className="hidden px-4 py-3 text-slate-500 md:table-cell">{r.reason}</td>
                <td className="hidden px-4 py-3 text-slate-400 md:table-cell">{new Date(r.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3"><Button size="sm" variant="ghost" className="text-red-600" onClick={() => del(r.id)} data-testid={`del-sup-${r.id}`}><Trash2 className="h-4 w-4" /></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
